import { Colors } from '../../theme'

export default {
  link: {
    color: Colors.Palette.primaryColor,
    textDecoration: 'underline'
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/link.js